/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step3body1Inputs */

const zh_landing_workflow_step3body1 = /** @type {(inputs: Landing_Workflow_Step3body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掌握度、用时和薄弱点热力图——无需手工表格。`)
};

const en_landing_workflow_step3body1 = /** @type {(inputs: Landing_Workflow_Step3body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mastery, time-on-task and weak-spot heatmaps — without spreadsheets.`)
};

const es_landing_workflow_step3body1 = /** @type {(inputs: Landing_Workflow_Step3body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio, tiempo invertido y mapas de calor de puntos débiles, sin hojas de cálculo.`)
};

/**
* | output |
* | --- |
* | "Mastery, time-on-task and weak-spot heatmaps — without spreadsheets." |
*
* @param {Landing_Workflow_Step3body1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step3body1 = /** @type {((inputs?: Landing_Workflow_Step3body1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step3body1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step3body1(inputs)
	if (locale === "en") return en_landing_workflow_step3body1(inputs)
	return es_landing_workflow_step3body1(inputs)
});
export { landing_workflow_step3body1 as "landing_workflow_step3Body" }